export const V_CREATING = "CREATING";
export const V_WAITING_FOR_ROOM_CODE = "WAITING_FOR_CODE";
export const V_CONNECTION_WARNING = "CONNECTION_WARNING";
export const V_WAITING_FOR_START = "WAITING_FOR_START";
export const V_QUESTION = "QUESTION";
export const V_FINAL = "FINAL";
